import React from 'react';
import { OpenTableSyncsTable } from '../components/OpenTableSyncs';

export const OpenTableSyncs = () => {
  return <OpenTableSyncsTable />;
};

export default OpenTableSyncs;
